<template>
  <div style="padding: 20px">
    <v-snackbar
      content-class="snackbar"
      :color="snackbar_background"
      right
      v-model="snackbar"
      :timeout="3000"
    >
      <v-icon :color="snackbar_icon_color" :size="64">{{
        snackbar_icon
      }}</v-icon>
      <h2 :style="{ color: snackbar_text_color + '!important' }" class="ml-16">
        {{ snackbar_text }}
      </h2>
      <v-btn
        @click="snackbar = false"
        fab
        dark
        text
        small
        style="
          margin-top: -6rem;
          float: right !important;
          margin-right: -1rem !important;
        "
      >
        <v-icon :color="snackbar_icon_color">mdi-window-close</v-icon>
      </v-btn>
    </v-snackbar>

    <!-- Dialog to confirm deletion of single Tempo -->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogdeletetempiconfirmation"
      width="500"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1 headline">
          <v-toolbar-title class="white--text"> Cancellazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mb-0 mt-5 pb-0">
          <span style="font-size: 18px">
            Sei sicuro di di voler eliminare questa riga?
          </span>
          <v-divider class="my-3"></v-divider>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-spacer></v-spacer>
                <v-btn
                  class="mr-5"
                  @click="dialogdeletetempiconfirmation = false"
                  small
                >
                  <v-icon color="error">mdi-close</v-icon>
                </v-btn>
                <v-btn @click="setValiditaTempi(null, 0)" small>
                  <v-icon color="success">mdi-check</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di aggiunta riga in Fermi -->
    <v-dialog persistent v-model="aggiungi_riga_fermi" width="800px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-row>
            <v-col align="left" cols="4">
              <v-toolbar-title class="white--text">
                Aggiungi Riga in Fermi
              </v-toolbar-title>
            </v-col>

            <v-col align="center" cols="4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="salvaFermo" small v-bind="attrs" v-on="on">
                    <v-icon color="success"> mdi-floppy </v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
            </v-col>

            <v-col align="right" cols="4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="aggiungi_riga_fermi = false"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="error"> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-toolbar>

        <v-card-text class="mt-5">
          <v-row align="center" justify="center">
            <v-col align="center" cols="6" justify="center">
              <v-autocomplete
                :items="items_causali_fermo"
                item-text="des"
                item-value="id_tabella"
                label="Causale di Fermo"
                style="max-width: 250px"
                v-model="new_fermo.id_causale"
              >
              </v-autocomplete>
            </v-col>
            <v-col align="center" cols="6" justify="center">
              <v-text-field
                class="centered-input"
                dense
                hide-details
                label="Minuti"
                style="
                  display: inline-block;
                  font-size: 35px;
                  font-weight: bold;
                  line-height: 35px;
                  max-width: 250px;
                  padding: 0px;
                "
                type="number"
                v-model="new_fermo.minuti"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di aggiunta riga in Pezzi -->
    <v-dialog persistent v-model="aggiungi_riga_pezzi" width="800px">
      <v-card>
        <!-- Toolbar -->
        <v-toolbar color="indigo" dense>
          <v-row>
            <v-col align="left" cols="4">
              <v-toolbar-title class="white--text">
                Aggiungi Riga in Pezzi
              </v-toolbar-title>
            </v-col>

            <v-col align="center" cols="4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="salvaPezzo" small v-bind="attrs" v-on="on">
                    <v-icon color="success"> mdi-floppy </v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
            </v-col>

            <v-col align="right" cols="4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="aggiungi_riga_pezzi = false"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="error"> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-toolbar>

        <!-- Corpo della card -->
        <v-card-text class="mt-5">
          <v-container>
            <v-row align="center" justify="center">
              <v-col align="center" cols="12" justify="center">
                <v-text-field
                  class="centered-input"
                  label="Quantità"
                  :min="0"
                  style="
                    display: inline-block;
                    font-size: 35px;
                    font-weight: bold;
                    line-height: 35px;
                    max-width: 200px;
                    padding: 0px;
                  "
                  type="number"
                  v-model="new_pezzo.quantita"
                />
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col align="center" cols="12">
                <v-textarea
                  v-model="new_pezzo.note"
                  placeholder="Note"
                  label="Note"
                  outlined
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di aggiunta riga in Scarti -->
    <v-dialog persistent v-model="aggiungi_riga_scarti" width="800px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-row>
            <v-col align="left" cols="4">
              <v-toolbar-title class="white--text">
                Aggiungi Riga in Scarti
              </v-toolbar-title>
            </v-col>

            <v-col align="center" cols="4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="salvaScarto" small v-bind="attrs" v-on="on">
                    <v-icon color="success"> mdi-floppy </v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
            </v-col>

            <v-col align="right" cols="4">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="aggiungi_riga_scarti = false"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="error"> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-toolbar>

        <v-card-text>
          <v-container>
            <v-row align="center" justify="center">
              <v-col align="center" cols="6" justify="center">
                <v-autocomplete
                  :items="items_causali_scarto"
                  item-text="des"
                  item-value="id_tabella"
                  label="Causale di Scarto"
                  style="max-width: 250px"
                  v-model="new_scarto.id_causale"
                >
                </v-autocomplete>
              </v-col>
              <v-col align="center" cols="6" justify="center">
                <v-text-field
                  class="centered-input"
                  dense
                  hide-details
                  label="Q.tà Scarti"
                  style="
                    display: inline-block;
                    font-size: 35px;
                    font-weight: bold;
                    line-height: 35px;
                    max-width: 250px;
                    padding: 0px;
                  "
                  type="number"
                  v-model="new_scarto.pezzi"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog per le tabelle collaterali -->
    <v-dialog persistent v-model="dialog_collaterali_visible" width="90%">
      <v-card style="overflow: hidden">
        <v-toolbar color="indigo" dense>
          <v-row>
            <v-col align="left" cols="4">
              <v-toolbar-title class="white--text">
                Tabelle Collaterali
              </v-toolbar-title>
            </v-col>

            <v-col align="center" cols="4">
              <!--<v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="salvaCollaterali"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="success"> mdi-floppy </v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>-->
            </v-col>

            <v-col align="right" cols="4">
              <!-- Bottone di chiusura del dialog -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="dialog_collaterali_visible = false"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="error"> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-toolbar>

        <v-card-text
          class="mt-5"
          style="max-height: 80vh; overflow-x: hidden; overflow-y: scroll"
        >
          <!-- Sottotabella dei pezzi -->
          <v-data-table
            class="tb-3"
            :headers="headers_coll_pezzi"
            height="20vh"
            :items="items_coll_pezzi"
          >
            <template v-slot:top>
              <v-toolbar color="indigo" dense>
                <v-row>
                  <v-col align="left" cols="4">
                    <v-toolbar-title class="white--text">
                      Pezzi Registrati
                    </v-toolbar-title>
                  </v-col>
                  <v-col align="center" cols="4">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="aggiungiRigaPezzi"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="primary"> mdi-plus </v-icon>
                        </v-btn>
                      </template>
                      <span>Aggiungi Riga</span>
                    </v-tooltip>
                  </v-col>

                  <v-col cols="4"></v-col>
                </v-row>
              </v-toolbar>
            </template>
          </v-data-table>

          <!-- Sottotabella dei scarti -->
          <v-data-table
            class="tb-3"
            :headers="headers_coll_scarti"
            height="20vh"
            :items="items_coll_scarti"
          >
            <template v-slot:top>
              <v-toolbar color="indigo" dense>
                <v-row>
                  <v-col align="left" cols="4">
                    <v-toolbar-title class="white--text">
                      Scarti
                    </v-toolbar-title>
                  </v-col>

                  <v-col align="center" cols="4">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="aggiungiRigaScarti"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="primary"> mdi-plus </v-icon>
                        </v-btn>
                      </template>
                      <span>Aggiungi Riga</span>
                    </v-tooltip>
                  </v-col>

                  <v-col cols="4"></v-col>
                </v-row>
              </v-toolbar>
            </template>
          </v-data-table>

          <!-- Sottotabella delle causali di fermo -->
          <v-data-table
            :headers="headers_coll_fermi"
            height="20vh"
            :items="items_coll_fermi"
          >
            <template v-slot:top>
              <v-toolbar color="indigo" dense>
                <v-row>
                  <v-col align="left" cols="4">
                    <v-toolbar-title class="white--text">
                      Causali di Fermo
                    </v-toolbar-title>
                  </v-col>

                  <v-col align="center" cols="4">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="aggiungiRigaFermi"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="primary"> mdi-plus </v-icon>
                        </v-btn>
                      </template>
                      <span>Aggiungi Riga</span>
                    </v-tooltip>
                  </v-col>

                  <v-col cols="4"></v-col>
                </v-row>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog per l'aggiunta di informazioni su più tabelle -->
    <v-dialog persistent v-model="dialog_riga_generale" width="92%">
      <AggiuntaRigaGenerale
        @salvata_riga="handleSalvataRiga"
        @click_chiudi="dialog_riga_generale = false"
        :key="key_aggiunta_riga_generale"
        :modalita="modalita_edit_riga_generale"
        :riga_ori="riga_sel"
      />
    </v-dialog>

    <!-- Dialog to Update Tempi -->
    <v-dialog
      v-model="update_tempi_dialog"
      width="800"
      content-class="hideOverlay"
    >
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Modifica Tempi</v-toolbar-title>
          <v-spacer></v-spacer>
          <Button
            colore_icona="success"
            idForm="AVANZAMENTO"
            idOggetto="SALVA_TEMPI"
            mdi_icona="mdi-floppy"
            testo_tooltip="Salva"
            v-on:buttonClick="salvaTempi"
          />
          <v-spacer></v-spacer>
          <v-btn light small @click="closeDialog">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col cols="2">
                  <TextField
                    :readonly="true"
                    idForm="C_TEMPI"
                    idOggetto="TEMPI_NUMERO_COMMESSA"
                    label_input="Numero Commessa"
                    palceholder_input="Numero Commessa"
                    :vmodel="numero_commessa"
                    v-on:changeText="(val) => (this.numero_commessa = val)"
                  />
                </v-col>
                <v-col cols="4">
                  <TextField
                    :readonly="true"
                    idForm="C_TEMPI"
                    idOggetto="TEMPI_COD_ARTICOLO"
                    label_input="Codice Articolo"
                    palceholder_input="Codice Articolo"
                    :vmodel="cod_articolo"
                    v-on:changeText="(val) => (this.cod_articolo = val)"
                  />
                </v-col>
                <v-col cols="3">
                  <TextField
                    :readonly="true"
                    idForm="C_TEMPI"
                    idOggetto="TEMPI_COD_FASE"
                    label_input="Codice Fase"
                    palceholder_input="Codice Fase"
                    :vmodel="cod_fase"
                    v-on:changeText="(val) => (this.cod_fase = val)"
                  />
                </v-col>
                <!-- <v-col cols="3" class="mt-4">
                  <v-menu
                    v-model="menu_pezzi"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formatDateTempi"
                        label="Data"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        dense
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="data"
                      @input="menu_pezzi = false"
                      locale="it"
                      first-day-of-week="1"
                    ></v-date-picker>
                  </v-menu>
                </v-col> -->
                <v-col cols="3" class="py-1 mt-n1">
                  <DateTimePicker
                    @returnVal="returnVal($event)"
                    title="Start"
                    placeholder="Start Date"
                    label="Start Date"
                    v-model="start"
                    :key="start"
                    :dataVal="start"
                  />
                </v-col>
                <v-col cols="3" class="py-1 mt-n1">
                  <DateTimePicker
                    @returnVal="returnVal($event)"
                    v-model="stop"
                    placeholder="Stop Date"
                    label="Stop Date"
                    title="Stop"
                    :key="stop"
                    :dataVal="stop"
                  />
                </v-col>
                <v-col cols="3" class="py-0">
                  <TextField
                    :readonly="true"
                    idForm="C_TEMPI"
                    idOggetto="TEMPI_ORE"
                    label_input="Ore"
                    palceholder_input="Ore"
                    :vmodel="ore"
                    v-on:changeText="(val) => (this.ore = val)"
                    :min_input="0"
                    type_input="number"
                  />
                </v-col>
                <v-col class="pt-4" cols="2">
                  <v-autocomplete
                    dense
                    hide-details
                    :items="items_turni"
                    item-text="cod_turno"
                    item-value="id_turno"
                    label="Turno"
                    v-model="turno"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-textarea
                    v-model="note"
                    placeholder="Note"
                    outlined
                    label="Note"
                    style="height: 150px"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Main Card to show Tempi Table -->
    <v-card>
      <v-toolbar primary-title class="white--text" color="indigo" dense>
        <v-toolbar-title>Tempi</v-toolbar-title>
        <v-spacer></v-spacer>
        <h3>Analisi Attuale: {{ analisi }}</h3>
        <Button
          classe_bottone="ml-5 mr-5"
          colore_icona="primary"
          idForm="AVANZAMENTO"
          idOggetto="TEMPI_ANALISI_SINTETICA"
          mdi_icona="mdi-table"
          testo_tooltip="Analisi Sintetica"
          v-on:buttonClick="getAvanzamentoTempi('s')"
        />
        <Button
          colore_icona="primary"
          idForm="AVANZAMENTO"
          idOggetto="TEMPI_ANALISI_DETTAGLIAATA"
          mdi_icona="mdi-table-search"
          testo_tooltip="Analisi Dettagliata"
          v-on:buttonClick="getAvanzamentoTempi('d')"
        />
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="clickAggiungiRigaGenerale"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary"> mdi-playlist-plus </v-icon>
            </v-btn>
          </template>
          <span>Dichiarazione di Produzione</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="clickAggiungiRigaTempi"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary"> mdi-plus </v-icon>
            </v-btn>
          </template>
          <span>Aggiungi Riga</span>
        </v-tooltip>

        <v-spacer></v-spacer>
        <!-- Input della data da -->
        <v-menu
          v-model="calendario_data_da"
          :close-on-content-click="false"
          :nudge-right="40"
          min-width="289"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <div
              class="mr-5"
              style="
                border: 1px solid black;
                display: inline-block;
                background-color: white;
                padding: 3px;
              "
            >
              <v-text-field
                background-color="#ffffff"
                class="custom-label-color"
                color="white"
                dense
                hide-details
                label="Data Da"
                v-model="data_da_formattata"
                readonly
                style="max-width: 100px"
                v-on="on"
              >
              </v-text-field>
            </div>
          </template>
          <v-date-picker
            v-model="data_da"
            @input="calendario_data_da = false"
          ></v-date-picker>
        </v-menu>

        <!-- Input della data a -->
        <v-menu
          v-model="calendario_data_a"
          :close-on-content-click="false"
          :nudge-right="40"
          min-width="289"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <div
              class="mr-5"
              style="
                border: 1px solid black;
                display: inline-block;
                background-color: white;
                padding: 3px;
              "
            >
              <v-text-field
                background-color="#ffffff"
                class="custom-label-color"
                color="white"
                dense
                hide-details
                label="Data A"
                v-model="data_a_formattata"
                readonly
                style="max-width: 100px"
                v-on="on"
              >
              </v-text-field>
            </div>
          </template>
          <v-date-picker
            v-model="data_a"
            @input="calendario_data_a = false"
          ></v-date-picker>
        </v-menu>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="getAvanzamentoTempi(analisi == 'sintetica' ? 's' : 'd')"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="primary"> mdi-magnify </v-icon>
            </v-btn>
          </template>
          <span>Cerca</span>
        </v-tooltip>

        <Button
          classe_bottone="mr-5"
          colore_icona="purple"
          idForm="AVANZAMENTO"
          idOggetto="TEMPI_FILTRA"
          :mdi_icona="
            filtra_menu_visible == true ? 'mdi-filter-off' : 'mdi-filter'
          "
          testo_tooltip="FILTRA"
          v-on:buttonClick="
            filtra_menu_visible = !filtra_menu_visible;
            ripristina();
          "
        />
        <v-tooltip v-if="show_btn_pezzi == true" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="clickPezzi" small v-bind="attrs" v-on="on">
              <v-icon color="primary">mdi-clipboard-text</v-icon>
            </v-btn>
          </template>
          <span>Consuntivo Pezzi</span>
        </v-tooltip>
        <!--<Button
          classe_bottone="mr-5"
          colore_icona="purple"
          idForm="AVANZAMENTO"
          idOggetto="TEMPI_RIPRISTINA"
          mdi_icona="mdi-filter-off"
          testo_tooltip="Ripristina"
          v-on:buttonClick="ripristina"
        />-->

        <v-spacer></v-spacer>
        <v-btn
          class="red--text"
          @click="clickChiudi"
          color="blue-grey lighten-5"
          small
        >
          <v-icon>mdi-keyboard-backspace</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-5" v-if="filtra_menu_visible">
        <v-row align="center" justify="center">
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_tempi_visualizzati"
              item-text="cod_commessa"
              item-value="cod_commessa"
              label="Cod. Commessa"
              style="display: inline-block; max-width: 350px"
              v-model="cod_commessa_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_commessa_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_commessa_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_tempi_visualizzati"
              item-text="cod_articolo"
              item-value="cod_articolo"
              label="Cod. Articolo"
              style="display: inline-block; max-width: 350px"
              v-model="cod_articolo_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_articolo_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_articolo_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_tempi_visualizzati"
              item-text="cod_fase"
              item-value="cod_fase"
              label="Cod. Fase"
              style="display: inline-block; max-width: 350px"
              v-model="cod_fase_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_fase_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_fase_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_tempi_visualizzati_computed"
              item-text="nominativo"
              item-value="nominativo"
              label="Operatore"
              style="display: inline-block; max-width: 350px"
              v-model="nome_operatore_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    nome_operatore_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    nome_operatore_search == ""
                      ? "mdi-filter"
                      : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_tempi_visualizzati"
              item-text="_data"
              item-value="_data"
              label="Data"
              style="display: inline-block; max-width: 350px"
              v-model="data_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    data_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    data_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_tempi_visualizzati"
              item-text="_start"
              item-value="_start"
              label="Start"
              style="display: inline-block; max-width: 350px"
              v-model="start_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    start_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    start_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_tempi_visualizzati"
              item-text="_stop"
              item-value="_stop"
              label="Stop"
              style="display: inline-block; max-width: 350px"
              v-model="stop_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    stop_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    stop_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_tempi_visualizzati"
              item-text="ore"
              item-value="ore"
              label="Ore"
              style="display: inline-block; max-width: 350px"
              v-model="ore_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    ore_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    ore_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table
        :headers="header_tempi"
        :items="items_tempi_visualizzati"
        class="elevation-1"
      >
        <!-- Pulsante per modificare -->
        <template v-slot:[`item.edit`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="handleClick(item)"
                small
                v-bind="attrs"
                v-show="item._stop != null && item._stop != ''"
                v-on="on"
              >
                <v-icon color="primary">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Modifica</span>
          </v-tooltip>
        </template>

        <!-- Pulsante per visualizzare le note -->
        <template v-slot:[`item.note`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                style="float: left"
                @click="clickNote(item)"
                small
                v-if="item.note != ''"
                v-on="on"
                v-bind="attrs"
              >
                <v-icon color="primary">mdi-clipboard-edit-outline</v-icon>
              </v-btn>
            </template>
            <span>Visualizza Note</span>
          </v-tooltip>
        </template>

        <!-- Pulsante per le tabelle collaterali -->
        <template v-slot:[`item.collaterali`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickCollaterali(item)"
                small
                v-on="on"
                v-bind="attrs"
              >
                <v-icon color="primary">mdi-magnify</v-icon>
              </v-btn>
            </template>
            <span>Info Collegate</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.delete`]="{ item }">
          <!-- Pulsante per cancellare -->
          <v-tooltip bottom v-if="item.validita == 1">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickCancellaTempi(item)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Elimina</span>
          </v-tooltip>

          <!-- Pulsante per riabilitare -->
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="setValiditaTempi(item, 1)"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-restore </v-icon>
              </v-btn>
            </template>
            <span>Riabilita</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialog delle note -->
    <v-dialog v-model="note_dialog_visible" width="75%">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Annotazioni</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="note_dialog_visible = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="text-align: left; overflow-y: auto">
          {{ note_tmp }}
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione dei fermi -->
    <v-dialog v-model="conferma_elimina_fermo" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare la riga di fermo selezionata?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="conferma_elimina_fermo = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="eliminaRigaFermi" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione degli scarti -->
    <v-dialog v-model="conferma_elimina_scarto" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare la riga di scarti selezionata?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="conferma_elimina_scarto = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="eliminaRigaScarti" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di aggiunta riga tempi -->
    <v-dialog v-model="dialog_aggiungi_tempi" persistent>
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Aggiunta Riga Tempi
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="aggiungiRigaTempi" small v-bind="attrs" v-on="on">
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Registra Riga</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogAggiungiTempi"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col cols="4">
                <v-text-field
                  dense
                  hide-details
                  label="Cod. Commessa"
                  outlined
                  v-model="cod_commessa_tmp"
                  style="border-radius: 0px"
                  v-on:keydown.enter="cercaCommesse"
                >
                  <template v-slot:append-outer>
                    <v-btn @click="cercaCommesse" small>
                      <v-icon color="primary"> mdi-magnify </v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  dense
                  hide-details
                  label="Cod. Fase"
                  :items="items_fasi_selezionabili"
                  item-text="cod_des_fase"
                  item-value="id_commessa_dettaglio"
                  outlined
                  v-model="id_commessa_dettaglio_tmp"
                  style="border-radius: 0px"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_macchine_selezionabili"
                  item-text="cod_des_macchina"
                  item-value="id_macchina"
                  label="Macchina"
                  outlined
                  v-model="id_macchina_tmp"
                  style="border-radius: 0px"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <!-- Data Start -->
              <v-col cols="3">
                <v-menu
                  v-model="calendario_data_start"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="289"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      background-color="#ffffff"
                      dense
                      hide-details
                      label="Data Start"
                      outlined
                      v-model="start_formattato"
                      readonly
                      style="border-radius: 0px"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    first-day-of-week="1"
                    locale="it"
                    v-model="start_tmp"
                    @input="calendario_data_start = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <!-- Ora start -->
              <v-col cols="3">
                <v-menu
                  v-model="calendario_ora_start"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      hide-details
                      v-model="ora_start_tmp"
                      label="Ora Start"
                      outlined
                      readonly
                      style="border-radius: 0px"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    format="ampm"
                    v-model="ora_start_tmp"
                    full-width
                    @click:minute="calendario_ora_start = false"
                  ></v-time-picker>
                </v-menu>
              </v-col>

              <!-- Data Stop -->
              <v-col cols="3">
                <v-menu
                  v-model="calendario_data_stop"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  min-width="289"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      dense
                      background-color="#ffffff"
                      hide-details
                      label="Data Stop"
                      outlined
                      v-model="stop_formattato"
                      readonly
                      style="border-radius: 0px"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                    first-day-of-week="1"
                    locale="it"
                    v-model="stop_tmp"
                    @input="calendario_data_stop = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <!-- Ora stop -->
              <v-col cols="3">
                <v-menu
                  v-model="calendario_ora_stop"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      hide-details
                      v-model="ora_stop_tmp"
                      label="Ora Stop"
                      outlined
                      readonly
                      style="border-radius: 0px"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    format="ampm"
                    v-model="ora_stop_tmp"
                    full-width
                    @click:minute="calendario_ora_stop = false"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione dei partner -->
    <v-dialog v-model="dialog_seleziona_commessa" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Selezione Commessa
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_seleziona_commessa = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-data-table
                  :headers="headers_commesse_selezionabili"
                  :items="items_commesse_selezionabili"
                >
                  <template v-slot:[`item.seleziona`]="{ item }">
                    <v-btn @click="selezionaCommessa(item)" small>
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Loader -->
    <v-overlay :value="caricamento_dati" absolute z-index="999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import moment from "moment";
import AggiuntaRigaGenerale from "./AggiuntaRigaGenerale.vue";
import Button from "../../../components/TOOLS/FormComponentPermissions/Button.vue";
import TextField from "../../../components/TOOLS/FormComponentPermissions/TextField";
import DateTimePicker from "../../TOOLS/DateTimePicker.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class CollateraleFermi {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "des", default_val: "" },
      { nome: "id_causale", default_val: null },
      { nome: "id_commessa", default_val: null },
      { nome: "id_commessa_causale", default_val: -1 },
      { nome: "id_commessa_dettaglio", default_val: null },
      { nome: "id_commessa_tempi", default_val: null },
      { nome: "minuti", default_val: null },
      { nome: "tipo_causale", default_val: "FERMO" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

class CollateralePezzi {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_articolo", default_val: null },
      { nome: "id_commessa", default_val: null },
      { nome: "id_commessa_dettaglio", default_val: null },
      { nome: "id_macchina", default_val: null },
      { nome: "note", default_val: "" },
      { nome: "quantita", default_val: 0 },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

class CollateraleScarti {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "des", default_val: "" },
      { nome: "id_causale", default_val: null },
      { nome: "id_commessa", default_val: null },
      { nome: "id_commessa_causale", default_val: -1 },
      { nome: "id_commessa_causali_produzione", default_val: -1 },
      { nome: "id_commessa_dettaglio", default_val: null },
      { nome: "id_commessa_tempi", default_val: null },
      { nome: "id_personale", default_val: null },
      { nome: "pezzi", default_val: null },
      { nome: "qta_commessa", default_val: 0 },
      { nome: "quantita", default_val: 0 },
      { nome: "_start", default_val: "" },
      { nome: "_stop", default_val: "" },
      { nome: "tipo_causale", default_val: "SCARTO" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

class RigaTempi {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "causale", default_val: "" },
      { nome: "cod_articolo", default_val: "" },
      { nome: "cod_commessa", default_val: "" },
      { nome: "cod_fase", default_val: "" },
      { nome: "cod_lotto", default_val: "" },
      { nome: "cod_macchina", default_val: "" },
      { nome: "cod_turno", default_val: "" },
      { nome: "_data", default_val: "" },
      { nome: "des_fase", default_val: "" },
      { nome: "flag_fase_ultima", default_val: 0 },
      { nome: "id_commessa", default_val: null },
      { nome: "id_commessa_dettaglio", default_val: null },
      { nome: "id_commessa_tempi", default_val: null },
      { nome: "id_fase", default_val: null },
      { nome: "id_macchina", default_val: null },
      { nome: "id_movimento", default_val: null },
      { nome: "id_personale", default_val: null },
      { nome: "id_stato_fase", default_val: null },
      { nome: "id_turno", default_val: null },
      { nome: "nominativo", default_val: "" },
      { nome: "note", default_val: "" },
      { nome: "numero_commessa", default_val: null },
      { nome: "_ora", default_val: "" },
      { nome: "ore", default_val: null },
      { nome: "riferimento", default_val: null },
      { nome: "saldo_fase", default_val: null },
      { nome: "_start", default_val: "" },
      { nome: "stato_commessa", default_val: null },
      { nome: "_stop", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "TabellaTempi",
  components: {
    AggiuntaRigaGenerale,
    DateTimePicker,
    Button,
    SnackbarQV,
    TextField,
  },
  props: {
    cod_commessa_sel: {
      type: String,
      default: "",
    },
    show_btn_pezzi: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      analisi: "",
      cod_articolo: null,
      cod_articolo_search: "",
      cod_commessa_search: "",
      cod_commessa_tmp: "",
      cod_fase: null,
      cod_fase_search: "",
      cod_macchina_search: "",
      data: "",
      data_a: null,
      data_da: null,
      data_search: "",
      id_commessa_tmp: null,
      id_commessa_dettaglio_tmp: null,
      id_macchina_tmp: null,
      isReset: false,
      items_tempi_visualizzati: [],
      key_aggiunta_riga_generale: 0,
      limite_mesi_passati: 0,
      modalita_edit_riga_generale: "",
      new_fermo: new CollateraleFermi(),
      new_pezzo: new CollateralePezzi(),
      new_scarto: new CollateraleScarti(),
      nome_operatore_search: "",
      note: "",
      note_tmp: "",
      numero_commessa: null,
      ora_start_tmp: "",
      ora_stop_tmp: "",
      ore: null,
      ore_search: "",
      riga_sel: new RigaTempi(),
      sel_tempi: {},
      snackbar: false,
      snackbar_background: "",
      snackbar_icon: "",
      snackbar_icon_color: "",
      snackbar_text: "",
      snackbar_text_color: "",
      start: null,
      start_search: "",
      start_tmp: "",
      stop: "",
      stop_tmp: "",
      stop_search: "",
      turno: null,

      // Modal
      aggiungi_riga_fermi: false,
      aggiungi_riga_pezzi: false,
      aggiungi_riga_scarti: false,
      calendario_data_a: false,
      calendario_data_da: false,
      calendario_data_start: "",
      calendario_data_stop: "",
      calendario_ora_start: "",
      calendario_ora_stop: "",
      caricamento_dati: false,
      conferma_elimina_fermo: false,
      conferma_elimina_scarto: false,
      dialog_aggiungi_tempi: false,
      dialog_collaterali_visible: false,
      dialogdeletetempiconfirmation: false,
      dialog_riga_generale: false,
      dialog_seleziona_commessa: false,
      filtra_menu_visible: false,
      menu_pezzi: false,
      note_dialog_visible: false,
      update_tempi_dialog: false,

      // Array
      headers_coll_fermi: [
        { text: "Cod. Commessa", value: "cod_commessa", sortable: false },
        { text: "Cod. Fase", value: "cod_fase", sortable: false },
        { text: "Des. Fase", value: "des_fase", sortable: false },
        { text: "Cod. Macchina", value: "cod_macchina", sortable: false },
        { text: "Data", value: "date_ins", sortable: false },
        { text: "Nominativo", value: "nominativo", sortable: false },
        { text: "Causale", value: "causale", sortable: false },
        { text: "Minuti", value: "minuti", sortable: false },
      ],
      headers_coll_pezzi: [
        {
          text: "Rif. Ordine",
          sortable: false,
          value: "riferimento",
        },
        {
          text: "Cod. Commessa",
          sortable: false,
          value: "cod_commessa",
        },
        {
          text: "Cod. Articolo",
          sortable: false,
          value: "cod_articolo",
        },
        {
          text: "Work Order",
          sortable: false,
          value: "cod_fase",
        },
        {
          text: "Des. Fase",
          sortable: false,
          value: "des_fase",
        },
        {
          text: "Data",
          sortable: false,
          value: "_data",
        },
        {
          text: "Data Dichiarazione",
          sortable: false,
          value: "_ora",
        },
        {
          text: "Nome",
          sortable: false,
          value: "nominativo",
        },
        {
          text: "Cod. Macchina",
          sortable: false,
          value: "cod_macchina",
        },
        {
          text: "Quantità",
          sortable: false,
          value: "quantita",
        },
      ],
      headers_coll_scarti: [
        { text: "Cod. Commessa", value: "cod_commessa", sortable: false },
        { text: "Cod. Fase", value: "cod_fase", sortable: false },
        { text: "Des. Fase", value: "des_fase", sortable: false },
        { text: "Cod. Macchina", value: "cod_macchina", sortable: false },
        { text: "Data", value: "date_ins", sortable: false },
        { text: "Nominativo", value: "nominativo", sortable: false },
        { text: "Causale", value: "causale", sortable: false },
        { text: "Q.tà Scarti", value: "pezzi", sortable: false },
      ],
      headers_commesse_selezionabili: [
        {
          text: "Selezione",
          value: "seleziona",
          sortable: false,
          width: "100px",
        },
        { text: "Cod. Commessa", value: "cod", sortable: false },
      ],
      header_tempi: [],
      header_tempi_sintetico: [
        {
          text: "Cod. Commessa",
          sortable: false,
          value: "cod_commessa",
        },
        {
          text: "Cod. Articolo",
          sortable: false,
          value: "cod_articolo",
        },
        {
          text: "Work Order",
          sortable: false,
          value: "cod_fase",
        },
        {
          text: "Data",
          sortable: false,
          value: "_data",
        },
        {
          text: "Ore",
          sortable: false,
          value: "ore",
        },
      ],
      header_tempi_dettagliato: [
        { text: "Note", sortable: false, value: "note" },
        {
          text: "Cod. Commessa",
          sortable: false,
          value: "cod_commessa",
        },
        {
          text: "Cod. Articolo",
          sortable: false,
          value: "cod_articolo",
        },
        {
          text: "Work Order",
          sortable: false,
          value: "cod_fase",
        },
        // {
        //   text: "Data",
        //   sortable: false,
        //   value: "_data",
        // },
        {
          text: "Nome",
          sortable: false,
          value: "nominativo",
        },
        {
          text: "Des. Macchina",
          sortable: false,
          value: "cod_macchina",
        },
        {
          text: "Start",
          sortable: false,
          value: "_start",
        },
        {
          text: "Stop",
          sortable: false,
          value: "_stop",
        },
        {
          text: "Turno",
          sortable: false,
          value: "cod_turno",
        },
        {
          text: "Ore",
          sortable: false,
          value: "ore",
        },
      ],
      items_causali_fermo: new Array(),
      items_causali_scarto: new Array(),
      items_coll_fermi: new Array(),
      items_coll_pezzi: new Array(),
      items_coll_scarti: new Array(),
      items_commesse_selezionabili: new Array(),
      items_fasi_selezionabili: new Array(),
      items_macchine_selezionabili: new Array(),
      items_tempi: new Array(),
      items_turni: new Array(),
    };
  },
  methods: {
    aggiungiRigaGenerale() {},
    aggiungiRigaFermi() {
      this.aggiungi_riga_fermi = true;
      this.new_fermo = new CollateraleFermi();

      this.new_fermo.cod_articolo = this.riga_sel.cod_articolo;
      this.new_fermo.cod_commessa = this.riga_sel.cod_commessa;
      this.new_fermo.cod_fase = this.riga_sel.cod_fase;
      this.new_fermo.cod_macchina = this.riga_sel.cod_macchina;
      this.new_fermo.date_ins = this.riga_sel._ora;
      this.new_fermo.des_fase = this.riga_sel.des_fase;
      this.new_fermo.cod_turno = this.riga_sel.cod_turno;
      this.new_fermo.id_commessa = this.riga_sel.id_commessa;
      this.new_fermo.id_commessa_dettaglio =
        this.riga_sel.id_commessa_dettaglio;
      this.new_fermo.id_commessa_movimenti = this.riga_sel.id_movimento;
      this.new_fermo.id_commessa_tempi = this.riga_sel.id_commessa_tempi;
      this.new_fermo.id_turno = this.riga_sel.id_turno;
      this.new_fermo.id_utente = this.riga_sel.id_utente;
      this.new_fermo.nominativo = this.riga_sel.nominativo;
    },
    aggiungiRigaPezzi() {
      this.aggiungi_riga_pezzi = true;
      this.new_pezzo = new CollateralePezzi();

      this.new_pezzo.id_articolo = this.riga_sel.id_articolo;
      this.new_pezzo.id_commessa = this.riga_sel.id_commessa;
      this.new_pezzo.id_commessa_dettaglio =
        this.riga_sel.id_commessa_dettaglio;
      this.new_pezzo.id_macchina = this.riga_sel.id_macchina;
    },
    aggiungiRigaScarti() {
      this.aggiungi_riga_scarti = true;
      this.new_scarto = new CollateraleScarti();

      this.new_scarto.id_commessa = this.riga_sel.id_commessa;
      this.new_scarto.id_commessa_dettaglio =
        this.riga_sel.id_commessa_dettaglio;
      this.new_scarto.id_commessa_tempi = this.riga_sel.id_commessa_tempi;
    },
    aggiungiRigaTempi() {
      // Controllo la commessa.
      if (this.id_commessa_tmp == null || this.id_commessa_tmp == "") {
        this.$refs.SnackbarQV.print("orange", "Selezionare una commessa.");
        return;
      }

      // Controllo la commessa dettaglio.
      if (
        this.id_commessa_dettaglio_tmp == null ||
        this.id_commessa_dettaglio_tmp == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Selezionare una fase di lavorazione."
        );
        return;
      }

      // Controllo la macchina.
      if (this.id_macchina_tmp == null || this.id_macchina_tmp == "") {
        this.$refs.SnackbarQV.print("orange", "Selezionare una macchina.");
        return;
      }

      // Controllo l'ora di start.
      if (this.ora_start_tmp == null || this.ora_start_tmp == "") {
        this.$refs.SnackbarQV.print(
          "orange",
          "Selezionare un orario di start."
        );
        return;
      }

      // Controllo lìora di stop.
      if (this.ora_stop_tmp == null || this.ora_stop_tmp == "") {
        this.$refs.SnackbarQV.print("orange", "Selezionare un orario di stop.");
        return;
      }

      // Controllo la data di start.
      if (this.start_tmp == null || this.start_tmp == "") {
        this.$refs.SnackbarQV.print("orange", "Selezionare una data di start.");
        return;
      }

      // Controllo la data di stop.
      if (this.stop_tmp == null || this.stop_tmp == "") {
        this.$refs.SnackbarQV.print("orange", "Selezionare una data di stop.");
        return;
      }

      // Controllo la coerenza delle date e delle ore.
      if (
        moment(`${this.start_tmp} ${this.ora_start_tmp}:00`).isAfter(
          moment(`${this.stop_tmp} ${this.ora_stop_tmp}:00`)
        )
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "I momenti di start e stop sono incompatibili."
        );
        return;
      }

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "addcommessatempi",
          token: localStorage.user_token,
          tempi: [
            {
              id_commessa_tempi: -1,
              id_personale: localStorage.id,
              id_commessa: this.id_commessa_tmp,
              id_commessa_dettaglio: this.id_commessa_dettaglio_tmp,
              id_macchina: this.id_macchina_tmp,
              data: `${this.stop_tmp} ${this.ora_stop_tmp}:00`,
              ora_inizio: `${this.start_tmp} ${this.ora_start_tmp}:00`,
              ora_fine: `${this.stop_tmp} ${this.ora_stop_tmp}:00`,
            },
          ],
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.dialog_aggiungi_tempi = false;
            this.id_commessa_tmp = null;
            this.cod_commessa_tmp = "";
            this.id_commessa_dettaglio_tmp = null;
            this.id_macchina_tmp = null;
            this.start_tmp = "";
            this.ora_start_tmp = "";
            this.stop_tmp = "";
            this.ora_stop_tmp = "";

            this.getAvanzamentoTempi(this.analisi == "sintetica" ? "s" : "d");
            this.filtra();

            this.$refs.SnackbarQV.print(
              "success",
              "Riga aggiunta con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server."
          );
        });
    },
    cercaCommesse() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessa",
          token: localStorage.user_token,
          cod_commessa: this.cod_commessa_tmp,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            if (res.data.lista.length === 1) {
              this.id_commessa_tmp = res.data.lista[0].id_commessa;
              this.cod_commessa_tmp = res.data.lista[0].cod_commessa;
              this.getFasiCommessa();
            } else if (res.data.lista.length > 0) {
              this.items_commesse_selezionabili = res.data.lista;
              this.dialog_seleziona_commessa = true;
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Nessuna commessa corrisponde alla ricerca."
              );
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    checkModificaConsentita(arg) {
      /* Se il limite dei mesi passati è 0 vuol dire che
       * non l'ho impostato, quindi ritorno sempre true. */
      if (this.limite_mesi_passati == 0) {
        return true;
      }

      let data = moment(arg);

      let terminus_ante_quem = moment(
        `${parseInt(
          moment().subtract(this.limite_mesi_passati, "months").format("YYYY")
        )}-${parseInt(
          moment().subtract(this.limite_mesi_passati, "months").format("M")
        )}-01`
      );

      /* Ritorno true solo se la data passata è successiva
       * ad "adesso" meno il limite temporale consentito. */
      return data.isSameOrAfter(terminus_ante_quem);
    },
    chiudiDialogAggiungiRigaGenerale() {
      this.dialog_riga_generale = false;
    },
    chiudiDialogAggiungiTempi() {
      this.dialog_aggiungi_tempi = false;
      this.id_commessa_tmp = null;
      this.cod_commessa_tmp = "";
      this.id_commessa_dettaglio_tmp = null;
      this.id_macchina_tmp = null;
      this.start_tmp = "";
      this.ora_start_tmp = "";
      this.stop_tmp = "";
      this.ora_stop_tmp = "";
    },
    clickAggiungiCollaterali() {
      this.dialog_collaterali_visible = true;
    },
    clickAggiungiRigaGenerale() {
      this.riga_sel = new RigaTempi();
      this.dialog_riga_generale = true;
      this.key_aggiunta_riga_generale =
        this.key_aggiunta_riga_generale == 1 ? 0 : 1;
      this.modalita_edit_riga_generale = "add";
    },
    clickAggiungiRigaTempi() {
      this.dialog_aggiungi_tempi = true;
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    clickPezzi() {
      this.$emit("click_tabella_pezzi");
      this.$emit("click_chiudi");
    },
    clickCollaterali(arg) {
      let is_modifica_consentita = this.checkModificaConsentita(
        `${arg._data.split("/")[2]}-${arg._data.split("/")[1]}-01`
      );

      if (!is_modifica_consentita) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Non è consentito modificare record così vecchi: il limite è ${this.limite_mesi_passati} mesi.`
        );
        return;
      }

      this.riga_sel = new RigaTempi(arg);

      if (this.riga_sel._start != null && this.riga_sel._start !== "") {
        this.riga_sel.data_start = `${this.riga_sel._start
          .split(" ")[0]
          .substring(6, 10)}-${this.riga_sel._start
          .split(" ")[0]
          .substring(3, 5)}-${this.riga_sel._start
          .split(" ")[0]
          .substring(0, 2)}`;
        this.riga_sel.ora_start = this.riga_sel._start.split(" ")[1];
      }

      if (this.riga_sel._stop != null && this.riga_sel._stop !== "") {
        this.riga_sel.data_stop = `${this.riga_sel._stop
          .split(" ")[0]
          .substring(6, 10)}-${this.riga_sel._stop
          .split(" ")[0]
          .substring(3, 5)}-${this.riga_sel._stop
          .split(" ")[0]
          .substring(0, 2)}`;
        this.riga_sel.ora_stop = this.riga_sel._stop.split(" ")[1];
      }

      this.dialog_riga_generale = true;
      this.key_aggiunta_riga_generale =
        this.key_aggiunta_riga_generale == 1 ? 0 : 1;
      this.modalita_edit_riga_generale = "edit";

      /*this.riga_sel = new RigaTempi(arg);
      this.dialog_collaterali_visible = true;
      this.getFermi();
      this.getPezzi();
      this.getScarti();*/
    },
    clickNote(item) {
      this.note_dialog_visible = true;
      this.note_tmp = item.note;
    },
    async getTurni() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getturnocodici",
          token: localStorage.user_token,
        },
      };

      await this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            for (let i = 0; i < res.data.result.turno_codici.length; i++) {
              this.items_turni.push(
                Object.assign({}, res.data.result.turno_codici[i])
              );
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    returnVal(obj) {
      switch (obj.title) {
        case "Start":
          this.start = moment(obj.val).format("DD/MM/YYYY HH:mm:ss");
          break;
        case "Stop":
          this.stop = moment(obj.val).format("DD/MM/YYYY HH:mm:ss");
          var ms = moment(this.stop, "DD/MM/YYYY HH:mm:ss").diff(
            moment(this.start, "DD/MM/YYYY HH:mm:ss")
          );
          var d = moment.duration(ms, "milliseconds");
          var hours = Math.floor(d.asHours());
          var mins = Math.floor(d.asMinutes()) - hours * 60;
          this.ore = `${hours}.${mins}`;
          break;
        default:
          break;
      }
    },
    clickEliminaRigaFermi(arg) {
      this.new_fermo = new CollateraleFermi(arg);
      this.conferma_elimina_fermo = true;
    },
    clickEliminaRigaScarti(arg) {
      this.new_scarto = new CollateraleScarti(arg);
      this.conferma_elimina_scarto = true;
    },
    // CLose Update Dialog
    closeDialog() {
      this.update_tempi_dialog = false;
    },
    getFasiCommessa() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessafull",
          token: localStorage.user_token,
          id_commessa: this.id_commessa_tmp,
          id_profilo: localStorage.id_profilo,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            res.data.commessa_dettaglio.forEach((f) => {
              f.cod_des_fase = `${f.cod_fase} - ${f.des}`;
            });

            this.items_fasi_selezionabili = res.data.commessa_dettaglio;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getListaMacchine() {
      const request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getlistamacchine",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            res.data.macchine.forEach((m) => {
              m.cod_des_macchina = `${m.des_macchina} - ${m.cod_macchina}`;
            });

            this.items_macchine_selezionabili = res.data.macchine;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server."
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server."
          );
        });
    },
    getVincoliModifica() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmodulialternativi",
          token: localStorage.user_token,
          codice: "CONSUNTIVI_TEMPI",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (!res.data.result) {
              return;
            }

            // Se l'array di risposta è vuoto non faccio nulla
            if (!res.data.result.length > 0) {
              return;
            }

            // Se l'array contiene informazioni per questo modulo, le registro.
            if (
              res.data.result.filter(
                (e) => e.descrizione === "LIMITE_MESI_PASSATI"
              ).length > 0
            ) {
              this.limite_mesi_passati = res.data.result.filter(
                (e) => e.descrizione === "LIMITE_MESI_PASSATI"
              )[0].val_int;
            }

            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nella comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    handleSalvataRiga() {
      this.dialog_riga_generale = false;
      this.getAvanzamentoTempi(this.analisi == "sintetica" ? "s" : "d");
    },
    salvaTempi() {
      const stop_formattato = moment(this.stop, ["DD/MM/YYYY HH:mm:ss"]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      const start_formattato = moment(this.start, [
        "DD/MM/YYYY HH:mm:ss",
      ]).format("YYYY-MM-DD HH:mm:ss");

      if (stop_formattato < start_formattato) {
        this.snackbar = true;
        this.snackbar_background = "orange";
        this.snackbar_icon = "mdi-alert";
        this.snackbar_icon_color = "white";
        this.snackbar_text =
          "La data d'inizio dell'attività deve precedere la data di conclusione.";
        this.snackbar_text_color = "white";
        return;
      }
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "updatecommessatempi",
          token: localStorage.getItem("user_token"),
          id_utente: localStorage.getItem("id"),
          id_movimento: this.sel_tempi.id_movimento,
          id_turno: this.turno,
          id_macchina: this.sel_tempi.id_macchina,
          ora_inizio: start_formattato,
          ora_fine: stop_formattato,
          validita: 1,
          note: this.note,
          id_causale:
            this.sel_tempi.id_causale == undefined
              ? null
              : this.sel_tempi.id_causale,
        },
      };
      this.$store.dispatch("api", request).then(() => {
        this.update_tempi_dialog = false;
        this.sel_tempi = null;
        this.getAvanzamentoTempi("d");
      });
    },
    setValiditaTempi(arg_obj = null, arg_validita) {
      if (arg_obj != null) {
        this.sel_tempi = JSON.parse(JSON.stringify(arg_obj));
      }

      /* Compongo una request per invalidare a DB
       * il tempo relativo alla riga selezionata. */
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessatempicrud",
          token: localStorage.user_token,
          tabella: [
            {
              id_commessa_tempi: this.sel_tempi.id_commessa_tempi,
              validita: arg_validita,
            },
          ],
        },
      };

      this.caricamento_dati = true;
      this.dialogdeletetempiconfirmation = false;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.caricamento_dati = false;
            this.getAvanzamentoTempi(this.analisi == "sintetica" ? "s" : "d");
            this.$refs.SnackbarQV.print(
              "success",
              "Dati aggiornati con successo."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile aggiornare i dati."
          );
        });
    },
    // IN order to make Filters work
    async eliminaRigaFermi() {
      const obj_tmp = {
        id_commessa_causale: this.new_fermo.id_commessa_causale,
        validita: 0,
      };
      await this.salvaBEFermi(obj_tmp);
      this.conferma_elimina_fermo = false;
    },
    async eliminaRigaScarti() {
      const obj_tmp = {
        id_commessa_causale: this.new_fermo.id_commessa_causale,
        validita: 0,
      };
      await this.salvaBEFermi(obj_tmp);
      this.conferma_elimina_scarto = false;
    },
    filtra() {
      let items_pezzi_tmp = [];
      this.items_tempi.forEach((elem) => {
        items_pezzi_tmp.push(elem);
      });
      // Filtro il cod_articolo
      if (this.cod_articolo_search != "") {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_pezzi_tmp.forEach((elem) => {
          if (elem.cod_articolo == this.cod_articolo_search) {
            res.push(elem);
          }
        });
        items_pezzi_tmp = res;
      }

      //Filtro il codice Fase
      if (this.cod_fase_search != "") {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_pezzi_tmp.forEach((elem) => {
          if (elem.cod_fase == this.cod_fase_search) {
            res.push(elem);
          }
        });
        items_pezzi_tmp = res;
      }

      //Filtro il codice Commessa
      if (this.cod_commessa_search != "") {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_pezzi_tmp.forEach((elem) => {
          if (elem.cod_commessa == this.cod_commessa_search) {
            res.push(elem);
          }
        });
        items_pezzi_tmp = res;
      }

      //   // Filtro il nome dell'operatore
      if (this.nome_operatore_search != "") {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_pezzi_tmp.forEach((elem) => {
          if (elem.nominativo == this.nome_operatore_search) {
            res.push(elem);
          }
        });
        items_pezzi_tmp = res;
      }
      if (this.start_search != "") {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_pezzi_tmp.forEach((elem) => {
          if (elem._start == this.start_search) {
            res.push(elem);
          }
        });
        items_pezzi_tmp = res;
      }
      // Filtro la data
      if (this.data_search != "") {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_pezzi_tmp.forEach((elem) => {
          if (elem._data == this.data_search) {
            res.push(elem);
          }
        });
        items_pezzi_tmp = res;
      }
      // Filtro la Stop
      if (this.stop_search != "") {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_pezzi_tmp.forEach((elem) => {
          if (elem._stop == this.stop_search) {
            res.push(elem);
          }
        });
        items_pezzi_tmp = res;
      }
      // Filtro la Stop
      if (this.ore_search != "") {
        // Faccio un array temporaneo
        let res = [];
        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_pezzi_tmp.forEach((elem) => {
          if (elem.ore == this.ore_search) {
            res.push(elem);
          }
        });
        items_pezzi_tmp = res;
      }
      this.items_tempi_visualizzati = [];
      this.items_tempi_visualizzati = items_pezzi_tmp;
    },
    getCausaliFermo() {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.user_token,
          tipo: "FASE_causali",
          filter: "validita = 1",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.causali = new Array();
            if (res.data) {
              this.items_causali_fermo = new Array();
              if (res.data.length > 0) {
                this.items_causali_fermo = res.data;
                return true;
              } else {
                return false;
              }
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati"
            );
            return false;
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati"
          );
        });
    },
    getCausaliScarto() {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.user_token,
          tipo: "PRODUZIONE_CAUSALI",
          filter: "validita = 1",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.causali = new Array();
            if (res.data) {
              this.items_causali_scarto = new Array();
              if (res.data.length > 0) {
                this.items_causali_scarto = res.data;
                return true;
              } else {
                return false;
              }
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati"
            );
            return false;
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati"
          );
        });
    },
    getFermi() {
      const nunc = moment();
      const terminus_ante_quem = nunc.subtract(7, "days");

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessacausali",
          token: localStorage.user_token,
          tipo: "FERMO",
          id_commessa_tempi: this.riga_sel.id_commessa_tempi,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_coll_fermi = new Array();
            res.data.result.commessa_causali.forEach((e) => {
              const data_tmp = moment(e.date_ins.substr(0, 10));
              if (data_tmp.isSameOrAfter(terminus_ante_quem)) {
                const riga_tmp = Object.assign({}, e);

                // Formatto come Dio comanda la data umana degli oggetti.
                riga_tmp.date_ins = `${e.date_ins.substr(
                  8,
                  2
                )}/${e.date_ins.substr(5, 2)}/${e.date_ins.substr(
                  0,
                  4
                )} ${e.date_ins.substr(11, 8)}
              `;

                // Metto negli oggetti la descrizione della causale.
                this.items_causali_fermo.forEach((c) => {
                  if (c.id_tabella == riga_tmp.id_causale) {
                    riga_tmp.des = c.des;
                  }
                });

                // Aggiungo l'oggetto all'array su cui lavorerà il FE.
                this.items_coll_fermi.push(riga_tmp);
              }
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getPezzi() {
      const nunc = moment();
      const terminus_ante_quem = nunc.subtract(7, "days");

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessaavanzamento",
          token: localStorage.getItem("user_token"),
          tipo: "p",
          analisi: "d",
          id_commessa_tempi: this.riga_sel.id_commessa_tempi,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        // Svuoto l'array che contiene i dati dell'avanzamento
        this.items_coll_pezzi = new Array();

        res.data.forEach((e) => {
          // Mi faccio una data di confronto.
          const data_tmp = moment(
            `${e._data.substr(6, 4)}-${e._data.substr(3, 2)}-${e._data.substr(
              0,
              2
            )}`
          );

          /* Se la data di confronto è pari o successiva al terminus
           * ante quem aggiungo l'oggetto della response. */
          if (data_tmp.isSameOrAfter(terminus_ante_quem)) {
            this.items_coll_pezzi.push(e);
          }
        });
      });
    },
    getScarti() {
      const nunc = moment();
      const terminus_ante_quem = nunc.subtract(7, "days");

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessacausali",
          token: localStorage.user_token,
          tipo: "SCARTO",
          id_commessa_tempi: this.riga_sel.id_commessa_tempi,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_coll_scarti = new Array();
            res.data.result.commessa_causali.forEach((e) => {
              const data_tmp = moment(e.date_ins.substr(0, 10));
              if (data_tmp.isSameOrAfter(terminus_ante_quem)) {
                const riga_tmp = Object.assign({}, e);

                // Formatto come Dio comanda la data umana degli oggetti.
                riga_tmp.date_ins = `${e.date_ins.substr(
                  8,
                  2
                )}/${e.date_ins.substr(5, 2)}/${e.date_ins.substr(
                  0,
                  4
                )} ${e.date_ins.substr(11, 8)}
              `;

                // Aggiungo la descrizione della causale di scarto.
                this.items_causali_scarto.forEach((c) => {
                  if (c.id_tabella === riga_tmp.id_causale) {
                    riga_tmp.des = c.des;
                  }
                });

                // Metto l'oggetto nell'array renderizzato in FE.
                this.items_coll_scarti.push(riga_tmp);
              }
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    // Function to Open Edit Modal for tempi
    handleClick(item) {
      let is_modifica_consentita = this.checkModificaConsentita(
        `${item._data.split("/")[2]}-${item._data.split("/")[1]}-01`
      );

      if (!is_modifica_consentita) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Non è consentito modificare record così vecchi: il limite è ${
            this.limite_mesi_passati
          } ${this.limite_mesi_passati == 1 ? "mese" : "mesi"}.`
        );
        return;
      }

      this.sel_tempi = item;
      this.numero_commessa = item.numero_commessa;
      this.cod_articolo = item.cod_articolo;
      this.cod_fase = item.cod_fase;
      this.data = moment(item._data, ["DD/MM/YYYY"]).format("YYYY-MM-DD");
      this.note = item.note;
      this.turno = item.id_turno;
      this.start = moment(item._start, ["DD/MM/YYYY HH:mm:ss"]).format(
        "DD/MM/YYYY HH:mm:ss"
      );
      this.stop = item._stop;
      this.ore = item.ore;
      this.update_tempi_dialog = true;
    },
    getAvanzamentoTempi(param) {
      const data_a_tmp = this.data_a.substr(0, 10);
      const data_da_tmp = this.data_da.substr(0, 10);

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessaavanzamento",
          token: localStorage.getItem("user_token"),
          tipo: "t",
          analisi: param,
          check: 0,
          data_da: data_da_tmp,
          data_a: data_a_tmp,
        },
      };
      this.caricamento_dati = true;
      this.$store.dispatch("api", request).then((res) => {
        // Definisco il tipo di analisi corrente in base alla chiamata
        this.analisi = param == "s" ? "sintetica" : "dettagliata";
        // Svuoto l'array che contiene i dati dell'avanzamento
        this.items_tempi = [];
        // Popolo l'array che contiene i dati totali
        res.data.forEach((elem) => {
          this.items_tempi.push(elem);
        });
        // Svuoto lo header dei e lo ripopolo a seconda dell'analisi
        if (param == "s") {
          this.header_tempi = [];
          this.header_tempi_sintetico.forEach((elem) => {
            this.header_tempi.push(elem);
          });
        } else if (param == "d") {
          this.header_tempi = [];
          this.header_tempi_dettagliato.forEach((elem) => {
            this.header_tempi.push(elem);
          });

          // Aggiungo la colonna di modifica.
          this.header_tempi.unshift({
            value: "edit",
            sortable: false,
          });

          // Aggiungo la colonna dei collaterali.
          this.header_tempi.unshift({
            value: "collaterali",
            sortable: false,
          });

          // Aggiungo la colonna di eliminazione.
          this.header_tempi.push({
            value: "delete",
            sortable: false,
            text: "Elimina/Riabilita",
          });
        }
        this.caricamento_dati = false;
      });
    },
    // async salvaCollaterali() {
    //   // Controllo che ci siano elementi da salvare.
    //   let acc_fermi = 0;
    //   let acc_pezzi = 0;
    //   let acc_scarti = 0;

    //   if (this.items_coll_fermi.length > 0) {
    //     if (
    //       this.items_coll_fermi.filter((f) => f.num_fermo != null).length > 0
    //     ) {
    //       acc_fermi = this.items_coll_fermi.filter((f) => f.num_fermo != null)
    //         .length;
    //     }
    //   }
    //   if (this.items_coll_pezzi.length > 0) {
    //     if (
    //       this.items_coll_pezzi.filter((p) => p.num_fermo != null).length > 0
    //     ) {
    //       acc_pezzi = this.items_coll_pezzi.filter((p) => p.num_fermo != null)
    //         .length;
    //     }
    //   }
    //   if (this.items_coll_scarti.length > 0) {
    //     if (
    //       this.items_coll_scarti.filter((s) => s.num_scarto != null).length > 0
    //     ) {
    //       acc_scarti = this.items_coll_scarti.filter(
    //         (s) => s.num_scarto != null
    //       ).length;
    //     }
    //   }

    //   if (acc_fermi == 0 && acc_pezzi == 0 && acc_scarti == 0) {
    //     this.$refs.SnackbarQV.print(
    //       "orange",
    //       "Non ci sono nuove righe da salvare."
    //     );
    //     return;
    //   }

    //   /* Ora so che ci sono elementi da salvare. Procedo a
    //    * salvare le tabelle che hanno elementi da salvare. */
    //   this.caricamento_dati = true;

    //   if (acc_fermi) {
    //     await this.salvaBEFermi();
    //   }

    //   if (acc_pezzi > 0) {
    //     await this.salvaBEPezzi();
    //   }

    //   if (acc_scarti > 0) {
    //     await this.salvaBEScarti();
    //   }

    //   this.$refs.SnackbarQV.print(
    //     "success",
    //     "Tabelle collaterali aggiornate correttamente."
    //   );

    //   this.caricamento_dati = false;
    //   this.dialog_collaterali_visible = false;
    // },
    salvaBEFermi(item) {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcausalicommessa",
          token: localStorage.user_token,
          tabella: [item],
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
          return false;
        });
    },
    salvaBEPezzi() {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessaregistrazione",
          token: localStorage.user_token,
          quantita: this.new_pezzo.quantita,
          id_commessa: this.riga_sel.id_commessa,
          id_commessa_dettaglio: this.riga_sel.id_commessa_dettaglio,
          id_commessa_tempi: this.riga_sel.id_commessa_tempi,
          id_macchina: this.riga_sel.id_macchina,
          id_personale: this.riga_sel.id_personale,
          data: this.riga_sel._stop,
          flag_fase_ultima: this.riga_sel.flag_fase_ultima,
          tipo_record: "M",
          chiudi_workorder:
            this.new_pezzo.quantita + this.riga_sel.quantita >
            this.riga_sel.qta_commessa
              ? 1
              : 0,
          note: this.new_pezzo.note,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
          return false;
        });
    },
    salvaBEScarti(item) {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcausalicommessa",
          token: localStorage.user_token,
          tabella: [item],
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
          return false;
        });
    },
    async salvaFermo() {
      const obj_tmp = Object.assign({}, this.new_fermo);

      // Assegno la descrizione della causale di fermo.
      this.items_causali_fermo.forEach((c) => {
        if (c.id_tabella === obj_tmp.id_causale) {
          obj_tmp.causale = c.des;
        }
      });

      await this.salvaBEFermi(obj_tmp);

      // Chiudo il dialog e aggiorno i dati.
      this.aggiungi_riga_fermi = false;
      this.getFermi();
    },
    async salvaPezzo() {
      await this.salvaBEPezzi();

      // Chiudo il dialog e aggiorno i dati.
      this.aggiungi_riga_pezzi = false;
      this.getPezzi();
    },
    async salvaScarto() {
      const obj_tmp = Object.assign({}, this.new_scarto);

      // Assegno la descrizione della causale di scarto.
      this.items_causali_scarto.forEach((c) => {
        if (c.id_tabella === obj_tmp.id_causale) {
          obj_tmp.causale = c.des;
        }
      });

      await this.salvaBEScarti(obj_tmp);

      // Chiudo il dialog e aggiorno i dati.
      this.aggiungi_riga_scarti = false;
      this.getScarti();
    },
    // In order to select tempo for delete
    clickCancellaTempi(item) {
      this.sel_tempi = item;
      this.dialogdeletetempiconfirmation = true;
    },
    selezionaCommessa(arg) {
      this.id_commessa_tmp = arg.id_commessa;
      this.cod_commessa_tmp = arg.cod;
      this.dialog_seleziona_commessa = false;
      this.getFasiCommessa();
    },
    ripristina() {
      this.cod_articolo_search = "";
      this.cod_commessa_search = "";
      this.cod_fase_search = "";
      this.data_search = "";
      this.start_search = "";
      this.stop_search = "";
      this.ore_search = "";
      this.items_tempi_visualizzati = [];
      this.items_tempi.forEach((el) => {
        this.items_tempi_visualizzati.push(el);
      });
    },
  },
  computed: {
    data_a_formattata() {
      return this.data_a != "" ? moment(this.data_a).format("DD/MM/YYYY") : "";
    },
    data_da_formattata() {
      return this.data_da != ""
        ? moment(this.data_da).format("DD/MM/YYYY")
        : "";
    },
    items_tempi_visualizzati_computed() {
      let arr = Array.from(this.items_tempi_visualizzati);
      arr.sort((a, b) =>
        a.nominativo > b.nominativo ? 1 : b.nominativo > a.nominativo ? -1 : 0
      );
      return arr;
    },
    formatDatePezzi() {
      return this.new_pezzo != null && this.new_pezzo != ""
        ? moment(this.new_pezzo._data).format("DD/MM/YYYY")
        : "";
    },
    formatDateTempi() {
      return this.data != null && this.data != ""
        ? moment(this.data).format("DD/MM/YYYY")
        : "";
    },
    start_formattato() {
      return this.start_tmp != ""
        ? moment(this.start_tmp).format("DD/MM/YYYY")
        : "";
    },
    stop_formattato() {
      return this.stop_tmp != ""
        ? moment(this.stop_tmp).format("DD/MM/YYYY")
        : "";
    },
  },
  watch: {
    stop: {
      immediate: true,
      deep: true,
      handler() {
        if (this.stop == undefined) {
          this.stop = "";
        }
      },
    },
    items_tempi: {
      immediate: true,
      deep: true,
      handler() {
        this.items_tempi_visualizzati = [];
        this.items_tempi.forEach((elem) => {
          // Aggiungo gli items ai pezzi visualizzati
          this.items_tempi_visualizzati.push(elem);
        });
        // Eseguo un filtro, caso mai l'utente ne abbia messo uno.
        this.filtra();
      },
    },
  },
  async mounted() {
    this.data_a = moment().format("YYYY-MM-DD");
    this.data_da = moment().subtract(7, "days").format("YYYY-MM-DD");

    // Colleziono le causali.
    this.getVincoliModifica();
    await this.getCausaliScarto();
    await this.getCausaliFermo();
    this.getTurni();
    this.getListaMacchine();

    /* Colleziono gli items della tabella
     * e uso le causali per valorizzare
     * la descrizione delle causali. */
    await this.getAvanzamentoTempi("s");

    /* Se la prop cod_commessa è valorizzata vuol dire
     * che devo inizializzare il componente filtrando
     * su quel cod_commessa, perché evidentemente questo
     * componente sta in un componente chiamante a cui
     *  interessa vedere solo una selezione di dati. */
    if (this.cod_commessa_sel !== "") {
      this.filtra_menu_visible = true;
      this.cod_commessa_search = this.cod_commessa_sel;
      this.filtra();
    }
  },
};
</script>
<style lang="css" >
.hideOverlay {
  overflow-y: hidden !important;
}
</style>
